import { Component, EventEmitter, Input, Output } from '@angular/core';
import { C4InputConfig, UIModule } from '@c4/ui';

@Component({
  selector: 'sysman-network-config-domain',
  templateUrl: './domain-config.component.html'
})
export class SysmanNetworkConfigDomainComponent {

  @Input() name: string;
  @Input() tagId: string;
  @Input() useDomain: boolean;
  @Input() domainName: string;

  @Output() valueChangeUseDomain: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueChangeDomainName: EventEmitter<string> = new EventEmitter<string>();

  domainOptions : Array<any> = [{name:"No Domain",value:false},{name:"Use the following",value:true}];
  
  inputConfig : C4InputConfig = {
      layout       : 'inline'
  }

  constructor() { 
  }
}


// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-network-config/domain-config.component.ts